import React from 'react';
import { color, boxShadow } from '../constants';
import styled from 'styled-components';
import { RaosWrapper } from 'raos';
import { Container } from 'react-bootstrap';
import { ReactComponent as HomeIcon } from '../imnages/home.svg';
import { ReactComponent as ReloadIcon } from '../imnages/f5.svg';
import { ReactComponent as LeftIcon } from '../imnages/arrow-left.svg';
import { ReactComponent as RightIcon } from '../imnages/arrow-right.svg';
import heroImg from '../imnages/raos.jpg';

const MainCont = styled.div`
  margin-top: 2rem;
  //height: 70vh;
  box-shadow: ${boxShadow.outset};
  border-radius: .5rem;
  padding: 0 1rem;
  padding-bottom: 1rem;
`
const Header = styled.div`
  display: flex;
  padding: .5rem 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  @media(min-width: 576px){
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`
const NavCont = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: .5rem 0;
  width: 100%;
  @media(min-width: 576px){
    width: auto;
    justify-content: space-between;
  }
`
const PseudoButton = styled.button`
  height: 30px;
  width: 30px;
  background: transparent;
  box-shadow: ${boxShadow.outset};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  margin-right: 1rem;
  flex-shrink: 0;
`
const PseudoInput = styled.p`
  width: 100%;
  padding: .5rem;
  border-radius: .5rem;
  margin: 0;
  flex-grow: 1;
  box-shadow: ${boxShadow.inset};
`
const Body = styled.div`
  border-radius: .5rem;
  padding: 1rem;
  box-shadow: ${boxShadow.inset};
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`
const CodeImg = styled.img`
  width: 80%;
  object-fit: cover;
  object-position: center;
`

export default ({ className }) => {

  return(
    <Container>
      <RaosWrapper percent={50} className={className}>
      <MainCont>
        <Header>
          <NavCont>
            <PseudoButton>
              <LeftIcon />
            </PseudoButton>
            <PseudoButton>
              <RightIcon />
            </PseudoButton>
            <PseudoButton>
              <ReloadIcon />
            </PseudoButton>
            <PseudoButton>
              <HomeIcon />
            </PseudoButton>
            <PseudoButton className="d-sm-none">X</PseudoButton>
          </NavCont>
          <PseudoInput>
            https://felixtineo.github.io/raos
          </PseudoInput>
          <PseudoButton className="d-none d-sm-block" style={{margin: 0, marginLeft: '1rem'}}>X</PseudoButton>
        </Header>
        <Body>

            <CodeImg src={heroImg} alt="raos react animation on scroll" />
        </Body>
      </MainCont>
      </RaosWrapper>
    </Container>
  )
}
